import type {
  UserLoginInterface,
  UserSignUp,
} from '../interfaces/auth.interface';

export const loginInitialState: UserLoginInterface = {
  username: '',
  password: '',
};

export const userSignUpInitialState: UserSignUp = {
  newUser: true,
  username: '',
  firstName: '',
  lastName: '',
  companyName: '',
  country: '',
  jobTitle: '',
  email: '',
  phoneNumber: '',
  zipPostalCode: '',
  password: '',
  passwordConfirm: '',
  acceptTerms: false,
};
